import { type as types } from "../types/index";

const initialState = {isScoreResult: false, isLoading: false, dataScoreResult: null};

export const ScoreResultReducer = (state = initialState, action) => {

    const {type, payload } = action;
    
    switch (type) {
        case types.getScoreResult:
            return {
                ...state,
                isScoreResult: true,
                dataScoreResult: payload
            };
        case types.getScoreResultFail:
            return {
                ...state,
                isScoreResult: false,
                dataScoreResult: null
            }
        default:
            return state;
    }
}
